var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

define(['underscore', 'core'], function(_, core) {
  var defaultSpecifiers, floorMoney, getCorrectSubtotal, getLedgerByDataEntry, getLedgerCategoryId, getTransactionsByCategories, isTaxLedgerCode, ledgers, taxes;
  taxes = {
    AB: {
      gst: 0.05
    },
    BC: {
      gst: 0.05,
      pst: 0.07
    },
    MB: {
      gst: 0.05,
      pst: 0.07
    },
    NB: {
      hst: 0.15
    },
    NF: {
      hst: 0.13
    },
    NS: {
      hst: 0.15
    },
    NT: {
      gst: 0.05
    },
    ON: {
      hst: 0.13
    },
    PE: {
      hst: 0.15
    },
    PQ: {
      gst: 0.05,
      qst: 0.09975
    },
    SK: {
      gst: 0.05,
      pst: 0.06
    },
    YT: {
      gst: 0.05
    }
  };
  ledgers = core.getDefaultLedgers();
  floorMoney = function(number) {
    return Math.round(number * 100) / 100;
  };
  getTransactionsByCategories = function(dataEntries, categories) {
    return _.filter(dataEntries, function(transaction) {
      var _ref;
      return _ref = getLedgerCategoryId(transaction), __indexOf.call(categories, _ref) >= 0;
    });
  };
  getLedgerCategoryId = function(dataEntry) {
    return getLedgerByDataEntry(dataEntry).categoryId;
  };
  getLedgerByDataEntry = function(dataEntry) {
    return _.findWhere(core.getCollection('ledgerAccounts').toJSON(), {
      id: dataEntry.ledgerAccountId
    });
  };
  defaultSpecifiers = ['hst', 'gst', 'pst', 'qst'];
  isTaxLedgerCode = function(code) {
    var taxLedgers, _ref, _ref1, _ref2;
    taxLedgers = _.compact([(_ref = ledgers['tax.payable']) != null ? _ref.code : void 0, (_ref1 = ledgers['tax.recover.meals']) != null ? _ref1.code : void 0, (_ref2 = ledgers['tax.recover']) != null ? _ref2.code : void 0]);
    return __indexOf.call(taxLedgers, code) >= 0;
  };
  getCorrectSubtotal = function(numberWithCorrectSign, numberToChange) {
    if (numberWithCorrectSign * numberToChange < 0) {
      return numberToChange * -1;
    } else {
      return numberToChange;
    }
  };
  return {
    getTax: function(province) {
      return taxes[province];
    },
    getPercentageSum: function(province, specifiers) {
      var sum, tax, _i, _len;
      sum = 0;
      for (_i = 0, _len = specifiers.length; _i < _len; _i++) {
        tax = specifiers[_i];
        if (!isNaN(taxes[province][tax])) {
          sum = floorMoney(sum + taxes[province][tax]);
        }
      }
      return floorMoney(sum);
    },
    getRecoverableTaxPortion: function(province, specifiers) {
      var recoverableTax;
      recoverableTax = _.filter(specifiers, function(spec) {
        return !isNaN(taxes[province][spec]) && spec !== 'pst';
      });
      return _.first(_.map(recoverableTax, function(spec) {
        return taxes[province][spec];
      }));
    },
    calculateSalesTax: function(amount, province, specifiers) {
      var amountBeforeTax, leftover, percentage, recoverableTax, tax;
      if (specifiers == null) {
        specifiers = defaultSpecifiers;
      }
      percentage = this.getPercentageSum(province, specifiers) + 1;
      amountBeforeTax = floorMoney(amount / percentage);
      recoverableTax = this.getRecoverableTaxPortion(province, specifiers);
      tax = (recoverableTax != null) ? floorMoney(recoverableTax * amountBeforeTax) : 0;
      leftover = floorMoney(amount - tax);
      return [amount, tax, leftover];
    },
    calculateFeeBasedSalesTax: function(amount, province, specifiers, subtotal) {
      var leftover, recoverableTax, tax;
      if (specifiers == null) {
        specifiers = defaultSpecifiers;
      }
      if (subtotal == null) {
        subtotal = amount;
      }
      recoverableTax = this.getRecoverableTaxPortion(province, specifiers);
      tax = (recoverableTax != null) ? floorMoney(recoverableTax * subtotal) : 0;
      subtotal = getCorrectSubtotal(amount, subtotal);
      leftover = floorMoney(amount - subtotal - tax);
      return [amount, tax, subtotal, leftover];
    },
    applySalesTax: function(documentModel, province, specifiers, subtotal) {
      var amount, amountBeforeTax, dataEntries, dataEntry, leftover, revenueExpenseDE, revenueExpenseLedger, revenuesExpenses, tax, taxLedger, _i, _len, _ref, _ref1;
      dataEntries = documentModel.get('dataEntries');
      for (_i = 0, _len = dataEntries.length; _i < _len; _i++) {
        dataEntry = dataEntries[_i];
        if (isTaxLedgerCode(getLedgerByDataEntry(dataEntry).code)) {
          return false;
        }
      }
      revenuesExpenses = getTransactionsByCategories(dataEntries, ['6', '7', '8']);
      if (revenuesExpenses.length !== 1) {
        return;
      }
      revenueExpenseDE = revenuesExpenses[0];
      if (revenueExpenseDE == null) {
        return false;
      }
      if (subtotal) {
        _ref = this.calculateFeeBasedSalesTax(revenueExpenseDE.amount, province, specifiers, subtotal), amount = _ref[0], tax = _ref[1], amountBeforeTax = _ref[2], leftover = _ref[3];
      } else {
        _ref1 = this.calculateSalesTax(revenueExpenseDE.amount, province, specifiers), amount = _ref1[0], tax = _ref1[1], amountBeforeTax = _ref1[2];
      }
      revenueExpenseLedger = getLedgerByDataEntry(revenueExpenseDE);
      taxLedger = (function() {
        switch (revenueExpenseLedger.categoryId) {
          case '6':
            return ledgers['tax.payable'];
          case '7':
            if (revenueExpenseLedger.code === ledgers['meals'].code) {
              return ledgers['tax.recover.meals'];
            } else {
              return ledgers['tax.recover'];
            }
            break;
          case '8':
            return ledgers['tax.recover'];
        }
      })();
      if (taxLedger == null) {
        taxLedger = ledgers['tax.payable'];
      }
      revenueExpenseDE.amount = amountBeforeTax;
      documentModel.addTransaction({
        amount: tax,
        entryType: tax < 0 ? 'CREDIT' : 'DEBIT',
        ledgerAccountId: taxLedger.id,
        foreignAmount: null,
        id: null
      });
      if (leftover != null) {
        revenueExpenseDE.amount += leftover;
      }
      documentModel.set('dataEntries', dataEntries);
      return true;
    },
    isTaxLedgerCode: isTaxLedgerCode
  };
});
